const kebabRegexp = /([a-z]|\s+)([A-Z])/g;
export const kebabCase = (string = '', delimiter = '-') => string.replace(kebabRegexp, `$1${delimiter}$2`).toLowerCase();

export const constructSeoTitle = (content, base) => {
    let seoTitle = base || "";
    if (content?.title && seoTitle.indexOf(content?.title) === -1) {
        seoTitle = `${content.title} | ${seoTitle}`
    }
    return seoTitle;
}

function multipleReplace(str: string, replacements: [string, string][]): string {
    return replacements.reduce((s, [from, to]) => s.replaceAll(from, to), str);
}
export function multiReplaceLtGt(str: string | undefined) {
    return str ? multipleReplace(str, [['<', '&lt;'], ['>', '&gt;']]) : str;
}

export function multiReplaceAmp(str: string | undefined) {
    return str ? multipleReplace(str, [['&', '&amp;']]) : str;
}